export const API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT || "http://localhost:5001";

export const PROVINCE_OPTIONS = [
  { label: "Koshi", value: "Koshi" },
  { label: "Madhesh", value: "Madhesh" },
  { label: "Bagmati", value: "Bagmati" },
  { label: "Gandaki", value: "Gandaki" },
  { label: "Lumbini", value: "Lumbini" },
  { label: "Karnali", value: "Karnali" },
  { label: "Sudurpashchim", value: "Sudurpashchim" },
];

export const ROLE_OPTIONS = [
  { label: "Admin", value: "admin" },
  { label: "Data Admin", value: "data-admin" },
  { label: "User", value: "user" },
];

export const PROVINCE_WISE_DISTRICT_OPTIONS = {
  Koshi: [
    { value: "Bhojpur", label: "Bhojpur" },
    { value: "Dhankuta", label: "Dhankuta" },
    { value: "Ilam", label: "Ilam" },
    { value: "Jhapa", label: "Jhapa" },
    { value: "Khotang", label: "Khotang" },
    { value: "Morang", label: "Morang" },
    { value: "Okhaldhunga", label: "Okhaldhunga" },
    { value: "Panchthar", label: "Panchthar" },
    { value: "Sankhuwasabha", label: "Sankhuwasabha" },
    { value: "Solukhumbu", label: "Solukhumbu" },
    { value: "Sunsari", label: "Sunsari" },
    { value: "Taplejung", label: "Taplejung" },
    { value: "Terhathum", label: "Terhathum" },
    { value: "Udayapur", label: "Udayapur" },
  ],
  Madhesh: [
    { value: "Bara", label: "Bara" },
    { value: "Dhanusha", label: "Dhanusha" },
    { value: "Mahottari", label: "Mahottari" },
    { value: "Parsa", label: "Parsa" },
    { value: "Rautahat", label: "Rautahat" },
    { value: "Saptari", label: "Saptari" },
    { value: "Sarlahi", label: "Sarlahi" },
    { value: "Siraha", label: "Siraha" },
  ],
  Bagmati: [
    { value: "Bhaktapur", label: "Bhaktapur" },
    { value: "Chitwan", label: "Chitwan" },
    { value: "Dhading", label: "Dhading" },
    { value: "Dolakha", label: "Dolakha" },
    { value: "Kathmandu", label: "Kathmandu" },
    { value: "Kavrepalanchok", label: "Kavrepalanchok" },
    { value: "Lalitpur", label: "Lalitpur" },
    { value: "Makwanpur", label: "Makwanpur" },
    { value: "Nuwakot", label: "Nuwakot" },
    { value: "Ramechhap", label: "Ramechhap" },
    { value: "Rasuwa", label: "Rasuwa" },
    { value: "Sindhuli", label: "Sindhuli" },
    { value: "Sindhupalchok", label: "Sindhupalchok" },
  ],
  Gandaki: [
    { value: "Gorkha", label: "Gorkha" },
    { value: "Kaski", label: "Kaski" },
    { value: "Lamjung", label: "Lamjung" },
    { value: "Manang", label: "Manang" },
    { value: "Mustang", label: "Mustang" },
    { value: "Myagdi", label: "Myagdi" },
    { value: "Nawalpur", label: "Nawalpur" },
    { value: "Parbat", label: "Parbat" },
    { value: "Syangja", label: "Syangja" },
    { value: "Baglung", label: "Baglung" },
    { value: "Tanahun", label: "Tanahun" },
  ],
  Lumbini: [
    { value: "Arghakhanchi", label: "Arghakhanchi" },
    { value: "Banke", label: "Banke" },
    { value: "Bardiya", label: "Bardiya" },
    { value: "Dang", label: "Dang" },
    { value: "Eastern Rukum", label: "Eastern Rukum" },
    { value: "Gulmi", label: "Gulmi" },
    { value: "Kapilvastu", label: "Kapilvastu" },
    { value: "Parasi", label: "Parasi" },
    { value: "Palpa", label: "Palpa" },
    { value: "Pyuthan", label: "Pyuthan" },
    { value: "Rolpa", label: "Rolpa" },
    { value: "Rupandehi", label: "Rupandehi" },
  ],
  Karnali: [
    { value: "Dailekh", label: "Dailekh" },
    { value: "Dolpa", label: "Dolpa" },
    { value: "Humla", label: "Humla" },
    { value: "Jajarkot", label: "Jajarkot" },
    { value: "Jumla", label: "Jumla" },
    { value: "Kalikot", label: "Kalikot" },
    { value: "Mugu", label: "Mugu" },
    { value: "Salyan", label: "Salyan" },
    { value: "Surkhet", label: "Surkhet" },
    { value: "Western Rukum", label: "Western Rukum" },
  ],
  Sudurpashchim: [
    { value: "Achham", label: "Achham" },
    { value: "Baitadi", label: "Baitadi" },
    { value: "Bajhang", label: "Bajhang" },
    { value: "Bajura", label: "Bajura" },
    { value: "Dadeldhura", label: "Dadeldhura" },
    { value: "Darchula", label: "Darchula" },
    { value: "Doti", label: "Doti" },
    { value: "Kailali", label: "Kailali" },
    { value: "Kanchanpur", label: "Kanchanpur" },
  ],
};
